import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import {
	Form,
	FormInput,
	FormButton,
	Margin,
	Text,
} from 'shared/components'
import { auth } from 'routes/route.map'

import * as styles from './styles'

const MobileResetFormComponent = ({
	form,
	onSubmitForm,
}) => {
	const history = useHistory()

	const handleBackClick = () => {
		history.push(auth.login())
	}

	return (
		<div css={styles.mobileContainer}>
			{/* Header with back arrow and title */}
			<div css={styles.header}>
				<FontAwesomeIcon
					icon="arrow-left"
					css={styles.backArrow}
					onClick={handleBackClick}
				/>
				<div css={styles.headerContent}>
					<Text as="h1" css={styles.title}>
						Reset Password
					</Text>
				</div>
			</div>

			{/* Form Content */}
			<div css={styles.formContainer}>
				<Margin bottom={4}>
					<Text css={styles.description}>
						Enter the email address associated with your InWin account.
					</Text>
				</Margin>

				<Form form={form} onSubmit={onSubmitForm} css={styles.form}>
					{/* Email Field */}
					<Margin bottom={4}>
						<FormInput
							name="email"
							type="email"
							placeholder="Email"
							css={styles.inputField}
						/>
					</Margin>

					{/* Reset Button */}
					<div css={styles.buttonContainer}>
						<FormButton submit css={styles.resetButton}>
							<Text css={styles.buttonText}>
								Reset
							</Text>
						</FormButton>
					</div>
				</Form>
			</div>

		</div>
	)
}

MobileResetFormComponent.propTypes = {
	form: PropTypes.shape().isRequired,
	onSubmitForm: PropTypes.func.isRequired,
}

export default observer(MobileResetFormComponent) 